import TextAlertSettings from './TextAlertSettings.component';

export default TextAlertSettings;
